import moment from "moment"
import { safeMoment } from "./safeDate.js"

// Every formatter here can be handed a raw stored value: an ISO string, a Date, a
// live dayjs from a picker, or a dayjs that lost its prototype on a JSON/redux
// round trip. moment() on any of the dayjs shapes yields "Invalid date", so those
// are converted to a real Date first and unusable values render as "" instead of
// "Invalid date". Strings and numbers are passed through untouched so the existing
// "parse as UTC, display as local" behaviour is unchanged.
const toLocal = (date) => {
    if (date === null || date === undefined || date === "") {
        return null
    }
    let input = date
    if (typeof input !== "string" && typeof input !== "number") {
        const parsed = safeMoment(input)
        if (!parsed.isValid()) {
            return null
        }
        input = parsed.toDate()
    }
    const local = moment(moment.utc(input).toDate()).local()
    return local.isValid() ? local : null
}

export const getLocalFormattedDate = (date) => {
    const local = toLocal(date)
    return local ? local.format('YYYY-MM-DD, hh:mm a') : ""
}

export const getLocalFormattedDateWithoutTime = (date) => {
    const local = toLocal(date)
    return local ? local.format('DD MMM, YYYY') : ""
}

export const getFormattedDate = (date) => {
    const local = toLocal(date)
    return local ? local.format('YYYY-MM-DD') : ""
}

export const getLocalDateFormatForWorkflow = (date) => {
    const local = toLocal(date)
    return local ? local.format('DD MMM, YYYY hh:mm a') : ""
}
